import { useCallback } from 'react';
import { extractPetInfoFromMessages } from '../utils/petExtractionUtils';

export interface PetInfo {
    petName: string;
    petType: 'dog' | 'cat' | 'both';
}

/**
 * Custom hook for extracting pet information from conversation messages
 * 
 * Handles:
 * - Pet name extraction using multi-language patterns
 * - Pet type detection (dog, cat, or both)
 * - Pattern validation for Chinese names
 * 
 * @returns extractPetInformation function
 */
export const usePetContext = () => {
    /**
     * Extract pet name and type from conversation messages
     * @param messages - Array of conversation messages
     * @returns PetInfo object with petName and petType
     */
    const extractPetInformation = useCallback((messages: any[]) => {
        return extractPetInfoFromMessages(messages);
    }, []);
    return {
        extractPetInformation
    };
};
